import React, { useContext, useEffect, useState } from "react";
import Invitation from "../../components/Invitation";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import AppContext from "../../AppContext";

const CompanyProfile = () => {
  const { id } = useParams();
  if (!id) return "NotFound";

  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
  };

  return <Invitation id={id} navigate={handleNavigate} />;
};

const CompanyPage = () => {
  return (
    <Routes>
      <Route path=":id" element={<CompanyProfile />} />
    </Routes>
  );
};

CompanyPage.propTypes = {};

export default CompanyPage;
